var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc_brand-tab"},[_c('div',{staticClass:"brand-main"},[_c('div',{staticClass:"brand-title"},[_c('div',{staticClass:"title-div"},[_vm._v(_vm._s(_vm.$t('PCBrandTab.index'))+":")])]),_c('PC-scroll-tab',{attrs:{"list":_vm.brandList,"active":_vm.active},on:{"handleSetActive":_vm.onTab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }